export default {
  items: [    
    {
      name: 'Marketing',
      url: '/marketing-social',
      icon: 'fa fa-bullhorn',
    }
  ],
};
